import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
app.initializers.add('email-notice', () => {
  extend('flarum/forum/components/SignUpModal', 'fields', function (items) {
    // Kontrollera om e-post-fältet existerar i listan
    if (items.has('email')) {
      // Hämta det befintliga e-post-fältet (som är ett Mithril vnode-objekt)
      const originalEmailField = items.get('email');

      // I Flarum 2.0 används metoden setContent() för att skriva över ett befintligt element
      items.setContent('email', m("div", {
        className: "Form-group-email-wrapper"
      }, originalEmailField, m("p", {
        className: "email-help-text"
      }, "E-postadressen \xE4r inte synlig f\xF6r allm\xE4nheten. \xC4r integritet viktigt f\xF6r dig rekommenderar vi att du skapar en anonym adress f\xF6r ditt konto p\xE5 Noden forum.")));
    }
  });
});